export const months = [
  { value: 1, label: 'Januari' },
  { value: 2, label: 'Februari' },
  { value: 3, label: 'Maret' },
  { value: 4, label: 'April' },
  { value: 5, label: 'Mei' },
  { value: 6, label: 'Juni' },
  { value: 7, label: 'Juli' },
  { value: 8, label: 'Agustus' },
  { value: 9, label: 'September' },
  { value: 10, label: 'Oktober' },
  { value: 11, label: 'November' },
  { value: 12, label: 'Desember' },
];

export const years = [2023, 2024, 2025, 2026];

export const statusColors = {
  draft: 'bg-gray-500 text-white border border-gray-600',
  processed: 'bg-blue-500 text-white border border-blue-600',
  approved: 'bg-purple-500 text-white border border-purple-600',
  paid: 'bg-green-500 text-white border border-green-600',
};

export const statusLabels = {
  draft: 'Draft',
  processed: 'Diproses',
  approved: 'Disetujui',
  paid: 'Dibayar',
};
